var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "deliverable-listing calendar-view" },
    [
      _c("FullCalendar", {
        ref: "csm__calendar",
        attrs: { options: Object.assign({}, _vm.calendarOptions) },
        scopedSlots: _vm._u([
          {
            key: "eventContent",
            fn: function(arg) {
              return [
                _c("div", { attrs: { id: "eventNo" + arg.event.id } }, [
                  typeof arg.event.extendedProps.deliverable != "undefined"
                    ? _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            arg.event.extendedProps.deliverable +
                              " > " +
                              arg.event.title
                          )
                        },
                        on: {
                          click: function($event) {
                            return _vm.handleEventTitleClick(arg)
                          }
                        }
                      })
                    : _c("span", {
                        domProps: { innerHTML: _vm._s(arg.event.title) },
                        on: {
                          click: function($event) {
                            return _vm.handleEventTitleClick(arg)
                          }
                        }
                      })
                ]),
                _vm._v(" "),
                _c(
                  "b-tooltip",
                  {
                    ref: "eventTooltip" + arg.event.id,
                    attrs: {
                      "custom-class": "calendar-due-date-tooltip",
                      delay: 0,
                      triggers: "manual",
                      target: "eventNo" + arg.event.id,
                      show:
                        _vm.calendarDueDateTooltip[
                          "eventTooltip" + arg.event.id
                        ]
                    }
                  },
                  [
                    _vm._v(
                      "\n        Due date: " +
                        _vm._s(
                          _vm.formatDueDateTooltip(
                            arg.event.extendedProps.dueDate
                          )
                        ) +
                        "\n      "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "dayCellContent",
            fn: function(arg) {
              return [
                _c(
                  "a",
                  {
                    staticClass: "fc-daygrid-day-number",
                    attrs: {
                      id: "fc-dom-4",
                      "aria-label": _vm
                        .$moment(arg.date)
                        .format("MMMM DD, YYYY")
                    }
                  },
                  [_vm._v(_vm._s(arg.dayNumberText))]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }